import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import './i18n';
import App from "./App";

import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.css";
import "global-components-library";

import {Provider} from 'react-redux'
import generateStore from './redux/store'

const store = generateStore()

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
serviceWorker.unregister();
